var map = {
	"./apple-touch-icon.png": 3569,
	"./favicon-16x16.png": 8737,
	"./favicon-32x32.png": 2977,
	"./hero-2.jpg": 3207,
	"./hero.jpg": 8418,
	"./icons/arrow-down.svg": 3176,
	"./icons/download.svg": 2400,
	"./icons/hamburger.svg": 9029,
	"./icons/home.svg": 3237,
	"./icons/x.svg": 1160,
	"./implications/implication-0.jpg": 7465,
	"./implications/implication-1.jpg": 9676,
	"./implications/implication-2.jpg": 6123,
	"./implications/implication-3.jpg": 5966,
	"./implications/implication-4.jpg": 8853,
	"./implications/implication-5.jpg": 1240,
	"./implications/implication-6.jpg": 9911,
	"./implications/implication-7.jpg": 1626,
	"./michel-antoine.jpg": 6509,
	"./mood/what-we-do.jpg": 7051,
	"./mood/who-we-are.jpg": 7644,
	"./mosaic-2.jpg": 2731,
	"./mosaic.jpg": 6734,
	"./partners/agnico-eagle.png": 6118,
	"./partners/alamos-gold.png": 6452,
	"./partners/arcelor-mittal.png": 8248,
	"./partners/asbestos.png": 8084,
	"./partners/asdr.png": 5566,
	"./partners/bagama.png": 7769,
	"./partners/barr.png": 1751,
	"./partners/barrick.png": 124,
	"./partners/bgm.png": 316,
	"./partners/black-iron.png": 2576,
	"./partners/bumigeb.png": 4715,
	"./partners/cameco.png": 3296,
	"./partners/canadian-royalties.png": 9428,
	"./partners/century.png": 8330,
	"./partners/cima.png": 6002,
	"./partners/cliffs.png": 9373,
	"./partners/detour-gold.png": 8028,
	"./partners/eldorado-gold.png": 9581,
	"./partners/goldcorp.png": 6218,
	"./partners/greenstone.png": 1892,
	"./partners/iamgold.png": 355,
	"./partners/imperial.png": 9803,
	"./partners/jeffrey.png": 9907,
	"./partners/kinross.png": 5211,
	"./partners/mason-graphite.png": 575,
	"./partners/metonor.png": 20,
	"./partners/mfq.png": 7324,
	"./partners/mine-canadian-calartic.png": 5037,
	"./partners/mine-raglan.png": 8423,
	"./partners/nal-catl.png": 1862,
	"./partners/nantou.png": 4437,
	"./partners/niobec.png": 1540,
	"./partners/nordgold.png": 8385,
	"./partners/noront.png": 7490,
	"./partners/nouveau-monde.png": 4481,
	"./partners/nyrstar.png": 5253,
	"./partners/orezone.png": 5908,
	"./partners/osisko.png": 5000,
	"./partners/pierres-steatites.png": 3961,
	"./partners/potash-corp.png": 5082,
	"./partners/rio-tinto-ioc.png": 1437,
	"./partners/rio-tinto.png": 5601,
	"./partners/robex.png": 4396,
	"./partners/semafo.png": 3863,
	"./partners/sirios.png": 7601,
	"./partners/snc-lavalin.png": 2524,
	"./partners/srg-graphite.png": 2251,
	"./partners/tacora.png": 3984,
	"./partners/wesdome.png": 2104,
	"./partners/wsp.png": 6664,
	"./silhouette.png": 6192,
	"./soutex-25ans.svg": 4873,
	"./soutex.svg": 6639,
	"./team/michel-bourassa.jpg": 9869,
	"images/apple-touch-icon.png": 3569,
	"images/favicon-16x16.png": 8737,
	"images/favicon-32x32.png": 2977,
	"images/hero-2.jpg": 3207,
	"images/hero.jpg": 8418,
	"images/icons/arrow-down.svg": 3176,
	"images/icons/download.svg": 2400,
	"images/icons/hamburger.svg": 9029,
	"images/icons/home.svg": 3237,
	"images/icons/x.svg": 1160,
	"images/implications/implication-0.jpg": 7465,
	"images/implications/implication-1.jpg": 9676,
	"images/implications/implication-2.jpg": 6123,
	"images/implications/implication-3.jpg": 5966,
	"images/implications/implication-4.jpg": 8853,
	"images/implications/implication-5.jpg": 1240,
	"images/implications/implication-6.jpg": 9911,
	"images/implications/implication-7.jpg": 1626,
	"images/michel-antoine.jpg": 6509,
	"images/mood/what-we-do.jpg": 7051,
	"images/mood/who-we-are.jpg": 7644,
	"images/mosaic-2.jpg": 2731,
	"images/mosaic.jpg": 6734,
	"images/partners/agnico-eagle.png": 6118,
	"images/partners/alamos-gold.png": 6452,
	"images/partners/arcelor-mittal.png": 8248,
	"images/partners/asbestos.png": 8084,
	"images/partners/asdr.png": 5566,
	"images/partners/bagama.png": 7769,
	"images/partners/barr.png": 1751,
	"images/partners/barrick.png": 124,
	"images/partners/bgm.png": 316,
	"images/partners/black-iron.png": 2576,
	"images/partners/bumigeb.png": 4715,
	"images/partners/cameco.png": 3296,
	"images/partners/canadian-royalties.png": 9428,
	"images/partners/century.png": 8330,
	"images/partners/cima.png": 6002,
	"images/partners/cliffs.png": 9373,
	"images/partners/detour-gold.png": 8028,
	"images/partners/eldorado-gold.png": 9581,
	"images/partners/goldcorp.png": 6218,
	"images/partners/greenstone.png": 1892,
	"images/partners/iamgold.png": 355,
	"images/partners/imperial.png": 9803,
	"images/partners/jeffrey.png": 9907,
	"images/partners/kinross.png": 5211,
	"images/partners/mason-graphite.png": 575,
	"images/partners/metonor.png": 20,
	"images/partners/mfq.png": 7324,
	"images/partners/mine-canadian-calartic.png": 5037,
	"images/partners/mine-raglan.png": 8423,
	"images/partners/nal-catl.png": 1862,
	"images/partners/nantou.png": 4437,
	"images/partners/niobec.png": 1540,
	"images/partners/nordgold.png": 8385,
	"images/partners/noront.png": 7490,
	"images/partners/nouveau-monde.png": 4481,
	"images/partners/nyrstar.png": 5253,
	"images/partners/orezone.png": 5908,
	"images/partners/osisko.png": 5000,
	"images/partners/pierres-steatites.png": 3961,
	"images/partners/potash-corp.png": 5082,
	"images/partners/rio-tinto-ioc.png": 1437,
	"images/partners/rio-tinto.png": 5601,
	"images/partners/robex.png": 4396,
	"images/partners/semafo.png": 3863,
	"images/partners/sirios.png": 7601,
	"images/partners/snc-lavalin.png": 2524,
	"images/partners/srg-graphite.png": 2251,
	"images/partners/tacora.png": 3984,
	"images/partners/wesdome.png": 2104,
	"images/partners/wsp.png": 6664,
	"images/silhouette.png": 6192,
	"images/soutex-25ans.svg": 4873,
	"images/soutex.svg": 6639,
	"images/team/michel-bourassa.jpg": 9869
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6947;